import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { CloudService } from '../cloud.service';
import { AuthService } from 'app/auth/auth.service';
import Swal from 'sweetalert2';
import { BehaviorSubject, Observable } from 'rxjs';

// idiomas
import { lang_fileman } from 'app/idiomas/i18n/fileMan/filemanager.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as catalogo from './catalogo';
import { carpetasInicialesBetter, carpetasInicialesAll } from './catalogo';

const moment = require('moment');

@Component({
  selector: 'tablaArchivos',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.scss'],
  animations   : fuseAnimations
})
export class TablaComponent implements OnInit {

  // @Input('listaArchivosEmpresa') listaArchivosEmpresa: backInter.getArchivosEmpresa;
  listaArchivosEmpresa: backInter.getArchivosEmpresa;
  @Input('puedeBorrar') puedeBorrar: boolean;

  private eventsSubscription: any
  @Input() actualizaArchivos: Observable<any>;
  @Input() versionLanding: Observable<any>;

  @Input() datosEmpresaSS: any;

  @Output() carpetaAbierta: EventEmitter<string> = new EventEmitter();
  @Output() enviaIdCarpeta: EventEmitter<string> = new EventEmitter();
  @Output() direccionActual: EventEmitter<string> = new EventEmitter();
  @Output() archivoNuevo: EventEmitter<any> = new EventEmitter();
  @Output() tipoCloudNuevo: EventEmitter<any> = new EventEmitter();

  nombresColumnas = ['icono','nombre', 'Extensión', 'Fecha de carga', 'tamaño', 'Descarga'];

  idiomaActual:string;

  carpetaActual = '';
  idCarpetaActual: string;
  datosCarpetaActual: any;
  nombreEmpresa: string;
  direccionRaiz = "./4fa42aa0ba652605cada43bca0fc6389/";

  htp:string;
  urlServidor:string;
  urlFileManager:string;
  idInstituto:string;
  urlFileServer:string;

  listaArchivos: any;
  listaArchivosSubCa: any;
  listaArchivosTemp: any;

  historial = [];
  boolsCarpInic = [false, false, false];
  carpetasIniciales = catalogo.carpetasIniciales;

  boolsCarpInicBetter = [false, false, false];
  carpetasInicialesBetter = catalogo.carpetasInicialesBetter;
  archivosInicialesBetter = catalogo.archivosInicialesBetter;

  boolsCarpInicMX = [false, false, false, false, false];
  carpetasInicialesMX = catalogo.carpetasInicialesMX;
  archivosInicialesMX = catalogo.archivosInicialesMX;

  boolsCarpInicCAYC = [false];
  carpetasInicialesCAYC = catalogo.carpetasInicialesCAYC;
  archivosInicialesCAYC = catalogo.archivosInicialesCAYC;

  boolsCarpInicAll= [false];
  carpetasInicialesAll = catalogo.carpetasInicialesAll;

  boolsCarpInicPublic = [false];
  carpetasInicialesPublic = catalogo.carpetasInicialesPublic;

  archivosInicialesNewCO = catalogo.archivosInicialesNewCO;

  /// VARIABLES NUEVOS SERVICIOS
  folderIdActual: string;
  listaSubcarpetasActual: any;
  cargandoArchivos: boolean;
  versionCloudNueva: boolean;
  fechaNuevaVersion = "2021-09-28";

  constructor(
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private cloudService: CloudService,
    private wizardService: WizardService,
    private authService:AuthService,
    private activatedRoute : ActivatedRoute,
  ) {
    lang_fileman.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    let url = DATOS_API.urlLogos.split(":");
    let htp = DATOS_API.urlLogos.split("/");
    this.htp = htp[0];
    this.urlServidor = url[1];
    this.urlFileManager = DATOS_API.urlFileManager;
    this.urlFileServer = DATOS_API.endpoints.cloud.getArchivo;
    console.log("URL SERVIDOR" + this.urlServidor);
    this.idInstituto = localStorage.getItem('instituto_id');

    this.activatedRoute.params.subscribe(params => {
      // console.log(params);
      if(params.version){
        console.log("parametro version de landing:",params.version);

        switch (params.version) {
          case 'legacy':
            this.fechaNuevaVersion = "2099-12-31";
          break;
          case 'current':
            this.fechaNuevaVersion = "1999-12-31";
          break;
        }
        this.revisionVersionCloud();
      } else{
        this.revisionVersionCloud();
      }
    });
  }

  ngOnInit() {
    this.idiomaActual = this.translateSrv.currentLang;
    this.eventsSubscription = this.actualizaArchivos.subscribe( (datos) => {
      // console.log("actualiza lista adicionales en traducciones");
      this.actualizarLista();
    });
    // this.versionLanding.subscribe( (datos) => {
    //   if(datos != null){
    //     console.log("datosVersionCloud:",datos);
    //
    //     switch (datos) {
    //       case true: this.fechaNuevaVersion = "2099-12-31"; break; //version 1
    //       case false: this.fechaNuevaVersion = "2021-09-28"; break; //version 2
    //     }
    //     this.revisionVersionCloud();
    //   }
    // });
    // this.revisionVersionCloud();
  }

  revisionVersionCloud(){
    this.cloudService.getInfoEmpresa(localStorage.getItem('companyID')).subscribe((respuesta:any) => {
      if(respuesta.message == 'Success'){
        this.nombreEmpresa = respuesta.data.nombreEmpresa;
        //REVISAR FECHA DE CREACION DE LA EMPRESA
        if(moment(respuesta.createdAt).isAfter(moment(this.fechaNuevaVersion)) ){  //si la fecha es posterior a la indicada, nueva version
          this.versionCloudNueva = true;
          this.tipoCloudNuevo.emit(true);
          this.nuevo_gotoRaiz();
        } else{   //version anterior
          this.gotoRaiz();
        }
      }
    });
  }

  /////SERVICIOS NUEVOS
  nuevo_gotoRaiz(){
    this.idCarpetaActual = null;
    this.datosCarpetaActual = null;
    this.direccionRaiz = localStorage.getItem('companyID');
    this.historial = [];
    this.enviaDireccionActual();
    this.enviaIdCarpetaActual(null);

    this.cloudService.getArchivos_nuevo("").subscribe((respuesta:any) => {
      console.log("getArchivos_nuevo raiz:",respuesta);
      if(respuesta.success){
        this.nuevo_getCarpeta(null, null, true);
      } else{
        this.nuevo_creaCarpetaRaiz();
      }
    });
  }
  nuevo_creaCarpetaRaiz(){
    const datos = {
      empresaId: localStorage.getItem('companyID'),
      folderId: null,
      path: localStorage.getItem('companyID'),
      itbm: true
    };
    this.cloudService.creaCarpeta_nuevo(datos).subscribe((respuesta:any) => {
      console.log("creaCarpeta_nuevo:",respuesta);
      this.nuevo_gotoRaiz();
    })
  }
  nuevo_getArchivos(ruta:string){
    const idEmpresa = localStorage.getItem('companyID');
    ruta = ruta.replace(new RegExp(idEmpresa,"g"),'');
    this.cloudService.getArchivos_nuevo(ruta).subscribe((respuesta:any) => {
      console.log("getArchivos_nuevo:",respuesta);
      if(respuesta.success){
        respuesta.records.forEach(registro => {
          if(registro.Type == 'File'){
            let nombreExt = registro.Path.split('.');
            this.listaArchivosTemp.push({
                carpetaId: this.datosCarpetaActual._id,
                vivo: 1,
                _id: "ID_DEL_ARCHIVO",
                nombre:registro.Path,
                nombreArchivoCode: this.encode(registro.Path),
                ubicacion: this.encode(this.datosCarpetaActual.path),
                tamanio: registro.Size,
                tipo: nombreExt[nombreExt.length - 1],
                createdAt: registro.LastModified
            });
          }
        });
        this.listaArchivos = this.listaArchivosTemp;
        this.cargandoArchivos = false;
        this.nuevo_revisaArchivosDefault_paso1();
        this.registroVacio();
        console.log("listaArchivos:",this.listaArchivos);
      }
    });
  }
  nuevo_getCarpeta(datosFolder?:any, subcarpetas?:boolean, raiz?: boolean){
    console.log("GET CARPETA NUEVO ALV:",{datosFolder: JSON.parse(JSON.stringify(datosFolder))});

    // if(this.idCarpetaActual != datosFolder._id){
      this.listaArchivos = [];
      this.cargandoArchivos = true;
      let folderId: string = null;
      if(datosFolder){
        this.datosCarpetaActual = datosFolder;
        folderId = datosFolder._id;
      }
      this.cloudService.getCarpetas_nuevo(folderId).subscribe((respuesta_2:any) => {
        console.log("getCarpetas_nuevo:",respuesta_2);
        if(respuesta_2.success){
          if(!subcarpetas){ /// PRIMER PASO, OBTENCION DE DATOS DE LA CARPETA
            this.listaArchivosTemp = [];
            if(raiz){
              this.datosCarpetaActual = respuesta_2.folders[0];
            }
            this.idCarpetaActual = this.datosCarpetaActual._id;
            console.log("datosCarpetaActual:",this.datosCarpetaActual);
            this.direccionRaiz = this.datosCarpetaActual.path;
            this.enviaDireccionActual();
            //hacer el get de nuevo para obtener las subcarpetas
            this.nuevo_getCarpeta(this.datosCarpetaActual, true);
            if(this.datosCarpetaActual.folderId){
              this.depuraHistorial(datosFolder);
            }
          } else{ /// SEGUNDO PASO, OBTENCION DE LISTA DE SUBCARPETAS Y ARCHIVOS
            this.listaArchivosTemp = [];
            const listaSubcarpetasActual: any = respuesta_2.folders;
            console.log("subcarpetas de la actual:",listaSubcarpetasActual);
            listaSubcarpetasActual.forEach(subcarpeta => {
              subcarpeta.tipoArchivo = 'folder';
              const nombreSubCarp = subcarpeta.path.split('/');
              subcarpeta.nombre = nombreSubCarp[nombreSubCarp.length - 1];
              if(!subcarpeta.itbm){
                this.listaArchivosTemp.push(subcarpeta);
              }
            });
            //revisa si ya existen subcarpetas, si alguna pertenece a las default
            this.nuevo_revisaSubcarpetaDefault();

            //revisa las carpetas default
            if(this.datosCarpetaActual.folderId == null || this.datosCarpetaActual.carpetaDef == true){
              if(this.idInstituto == '1' || this.idInstituto == 'MX'){
                this.nuevo_revisaCarpetasDefault_paso1(1);
              }
              if(this.idInstituto == '2' || this.idInstituto == 'CAYC'){
                this.nuevo_revisaCarpetasDefault_paso1(2);
              }
              if(localStorage.getItem('producto35') == "1" || localStorage.getItem('Leveuser') == "6"){
                this.nuevo_revisaCarpetasDefault_paso1(3);
              }
              // this.nuevo_revisaCarpetasDefault_paso1(4);  //las iniciales public se revisan sin importar el broker
            }

            //hace el get de los archivos
            this.nuevo_getArchivos(this.datosCarpetaActual.path);
            console.log("listaArchivosTemp:",this.listaArchivosTemp);
          }
        }
      });
    // }
  }
  nuevo_guardaCarpeta(){
    let regexNombre = new RegExp("^[a-zA-Z0-9 _]*$");
    let texto = this.translateSrv.instant('FILEMANAGER.MENSAJES.CREATEFOLDER');
    let rspSi = this.translateSrv.instant('FILEMANAGER.MENSAJES.BOTONES.CREAR');
    let rspNo = this.translateSrv.instant('FILEMANAGER.MENSAJES.BOTONES.CANCELAR');
    Swal.fire({
      title: texto,
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: rspSi,
      cancelButtonText: rspNo,
      showLoaderOnConfirm: true,

      allowOutsideClick: () => !Swal.isLoading(),
      inputValidator: (value) => {
        if (!regexNombre.test(value)) {
          return this.translateSrv.instant('FILEMANAGER.MENSAJES.INVALID_CHARS')
        }
      }
    }).then((result) => {
      if (result.value) {
        const datos = {
          empresaId: localStorage.getItem('companyID'),
          folderId: this.datosCarpetaActual._id,
          path: this.datosCarpetaActual.path + '/' + result.value,
          itbm: false
        };

        this.cloudService.creaCarpeta_nuevo(datos).subscribe((respuesta:any) => {
          console.log("creaCarpeta_nuevo:",respuesta);
          if(respuesta.success){
            this.mensajeSwal('FILEMANAGER.MENSAJES.FOLDEROK',1);
            this.actualizarLista();
          } else{
            this.mensajeSwal('FILEMANAGER.MENSAJES.'+respuesta.message,3);
          }
        });
      }
    });
  }

  nuevo_borraArchivo(ubicacion:string, opcion:number){
    let texto:string;
    switch (opcion) {
      case 1: texto = this.translateSrv.instant('FILEMANAGER.MENSAJES.DELETERLY'); break;
      case 2: texto = this.translateSrv.instant('FILEMANAGER.MENSAJES.DELETEFOLDERRLY'); break;
    }
    let rspSi = this.translateSrv.instant('FILEMANAGER.MENSAJES.BOTONES.SI');
    let rspNo = this.translateSrv.instant('FILEMANAGER.MENSAJES.BOTONES.NO');

    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        switch (opcion) {
          case 1: //archivo
            this.cloudService.borraArchivo_nuevo(decodeURIComponent(ubicacion)).subscribe( (data:any) => {
              console.log("borraArchivo_nuevo:",data);
              if(data.success){
                this.mensajeSwal('FILEMANAGER.MENSAJES.DELETEOK',1);
                this.actualizarLista();
              }
            });
          break;
          // case 2: //carpeta
          //   this.cloudService.borraCarpeta(idArchivo).subscribe( (data:backInter.RespuestaGen) => {
          //   if(data.success){
          //       this.mensajeSwal('FILEMANAGER.MENSAJES.DELETEFOLDEROK',1);
          //       this.actualizarLista();
          //     }
          //     console.log(data);
          //   });
          // break;
        }
      }
    });
  }

  nuevo_revisaCarpetasDefault_paso1(tipoCarpetas:number){
    let refCarpetasDefault: any;
    let banderaCarpDef: any;
    switch (tipoCarpetas) {
      case 1: refCarpetasDefault = this.carpetasInicialesMX; banderaCarpDef = "carpetaMx"; break;
      case 2: refCarpetasDefault = this.carpetasInicialesCAYC; banderaCarpDef = "carpetaCayc"; break;
      case 3: refCarpetasDefault = this.carpetasInicialesBetter; banderaCarpDef = "carpetaBetter"; break;
      case 4: refCarpetasDefault = this.carpetasInicialesPublic; banderaCarpDef = "carpetaPub"; break;
    }
    console.log("revisa carp default paso1, datos:",{
      listaArchivosTemp:JSON.parse(JSON.stringify(this.listaArchivosTemp)),
      refCarpetasDefault,
      banderaCarpDef
    });
    this.listaArchivosTemp.forEach(carpeta => {
      // carpeta.tipoArchivo = 'folder';
      var BreakException = {};
      try {
        refCarpetasDefault.forEach((carpetaDefault, i) => {
          if(carpeta.nombre == carpetaDefault.carpeta){
            carpeta.carpetaDef = true;
            carpeta[banderaCarpDef] = true;
            carpeta.visible = carpetaDefault.visible;
            throw BreakException;
          }
        });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
    });
    this.nuevo_revisaCarpetasDefault_paso2(tipoCarpetas);
  }
  nuevo_revisaCarpetasDefault_paso2(tipoCarpetas:number){
    let refCarpetasDefault: any;
    let refBoolsCarpDef: any;
    let banderaCarpDef: any;
    switch (tipoCarpetas) {
      case 1: refCarpetasDefault = this.carpetasInicialesMX; banderaCarpDef = "carpetaMx"; refBoolsCarpDef = this.boolsCarpInicMX; break;
      case 2: refCarpetasDefault = this.carpetasInicialesCAYC; banderaCarpDef = "carpetaCayc"; refBoolsCarpDef = this.boolsCarpInicCAYC; break;
      case 3: refCarpetasDefault = this.carpetasInicialesBetter; banderaCarpDef = "carpetaBetter"; refBoolsCarpDef = this.boolsCarpInicBetter; break;
      case 4: refCarpetasDefault = this.carpetasInicialesPublic; banderaCarpDef = "carpetaPub"; refBoolsCarpDef = this.boolsCarpInicPublic; break;
    }
    console.log("revisa carp default paso2, datos:",{
      listaArchivosTemp: JSON.parse(JSON.stringify(this.listaArchivosTemp)),
      refCarpetasDefault,
      refBoolsCarpDef
    });
    this.listaArchivosTemp.forEach(carpetaActual => {
      if(carpetaActual.tipoArchivo == 'folder'){
        refCarpetasDefault.forEach((carpetaDefault, i) => {
          if(carpetaActual.nombre == carpetaDefault.carpeta){
            refBoolsCarpDef[i] = true;
          }
        });
      }
    });
    console.log("refBoolsCarpDef:",refBoolsCarpDef);

    refCarpetasDefault.forEach((carpetaDefault,i) => {
      if(!refBoolsCarpDef[i])
        this.nuevo_creaCarpetaDef(carpetaDefault,i,tipoCarpetas);
    });
  }
  nuevo_creaCarpetaDef(nomCarpeta: any, numCarpeta: number, origen: number){
    console.log("entra a creaCarpetaDef");

    let refBoolsCarpDef: any;
    switch (origen) {
      case 1: refBoolsCarpDef = this.boolsCarpInicMX; break;
      case 2: refBoolsCarpDef = this.boolsCarpInicCAYC; break;
      case 3: refBoolsCarpDef = this.boolsCarpInicBetter; break;
      case 4: refBoolsCarpDef = this.boolsCarpInicPublic; break;
    }
    const datos = {
      empresaId: localStorage.getItem('companyID'),
      folderId: this.datosCarpetaActual._id,
      path: this.datosCarpetaActual.path + '/' + nomCarpeta.carpeta,
      itbm: false
    };

    this.cloudService.creaCarpeta_nuevo(datos).subscribe((respuesta:any) => {
      if(respuesta.success){
        refBoolsCarpDef[numCarpeta] = true;
        const carpetaCreada = (status) => status === true;
        if(refBoolsCarpDef.every(carpetaCreada)){
          this.actualizarLista();
        }
        if(nomCarpeta.subcarpeta.length > 0){
          nomCarpeta.subcarpeta.forEach((subcarpeta) => {
            this.nuevo_creaSubcarpetas(respuesta.newFolder,subcarpeta);
          });
        }
      }
    });
  }
  nuevo_creaSubcarpetas(padre:any, actual:any){
    const datos = {
      empresaId: localStorage.getItem('companyID'),
      folderId: padre._id,
      path: padre.path + '/' + actual.carpeta,
      itbm: false
    };
    this.cloudService.creaCarpeta_nuevo(datos).subscribe((respuesta:any) => {
      if(respuesta.success){
        if(actual.subcarpeta.length > 0){
          actual.subcarpeta.forEach((subcarpeta) => {
            this.nuevo_creaSubcarpetas(respuesta.newFolder,subcarpeta);
          });
        }
      }
    });
  }

  nuevo_revisaSubcarpetaDefault(){
    const referencias = [
      { bandera: 'carpetaMx', arrCarpetas: this.carpetasInicialesMX },
      { bandera: 'carpetaCayc', arrCarpetas: this.carpetasInicialesCAYC },
      { bandera: 'carpetaBetter', arrCarpetas: this.carpetasInicialesBetter },
      // { bandera: 'carpetaPub', arrCarpetas: this.carpetasInicialesPublic },
    ];
    console.log("revisa sub carpetasdefault datos:",{
      listaArchivosTemp: this.listaArchivosTemp,
      datosCarpetaActual: this.datosCarpetaActual
    });

    referencias.forEach(setRef => {
      this.listaArchivosTemp.forEach(carpeta => {
        if(this.datosCarpetaActual[setRef.bandera]){
          //buscar archvos subcarpeta
          let subcarpetaEncontrada = this.buscaSubcarpetaDefault(carpeta.nombre, setRef.arrCarpetas);
          if(subcarpetaEncontrada == true){
            console.log("subcarpetaEncontrada:",subcarpetaEncontrada);
            carpeta.carpetaDef = true;
            carpeta[setRef.bandera] = true;
          }
        }
      });
    });
    this.nuevo_revisaSubcarpetaDefault_faltante();
  }
  nuevo_revisaSubcarpetaDefault_faltante(){
    const referencias = [
      { bandera: 'carpetaMx', arrCarpetas: this.carpetasInicialesMX },
      { bandera: 'carpetaCayc', arrCarpetas: this.carpetasInicialesCAYC },
      { bandera: 'carpetaBetter', arrCarpetas: this.carpetasInicialesBetter },
      // { bandera: 'carpetaPub', arrCarpetas: this.carpetasInicialesPublic },
    ];
    referencias.forEach(broker => {
      if(this.datosCarpetaActual[broker.bandera] != undefined){
        const listaSubcarpetas = this.nuevo_revisaSubcarpetaDefault_faltante_paso2(broker.arrCarpetas);
        console.log("lista de subcarpetas default de esta carpeta default:",listaSubcarpetas);
        if(listaSubcarpetas != undefined){
          listaSubcarpetas.subcarpeta?.length > 0 ? this.nuevo_revisaSubcarpetaDefault_faltante_paso3(listaSubcarpetas.subcarpeta) : false;
        }
      }
    });
  }
  nuevo_revisaSubcarpetaDefault_faltante_paso2(arreglo:any){
    console.log("entró paso2:",arreglo, this.datosCarpetaActual);

    //primer recorrido
    let reco_1_fnd: any;
    var BreakException_1 = {};
    try {
      arreglo.forEach(carpeta => {
        if(carpeta.carpeta == this.datosCarpetaActual.nombre){
          reco_1_fnd = carpeta;
          throw BreakException_1;
        }
      });
    } catch (e) {
      if (e !== BreakException_1) throw e;
    }
    //si en el primer recorrido no se encontró, se recorre de nuevo dentro de su arreglo de subcarpetas
    if(reco_1_fnd == undefined){
      console.log("no se encontró coincidencia a nivel: ",arreglo);

      var BreakException_2 = {};
      try {
        arreglo.forEach(carpeta => {
          if(carpeta.subcarpeta.length > 0){
            reco_1_fnd = this.nuevo_revisaSubcarpetaDefault_faltante_paso2(carpeta.subcarpeta);
            console.log("valor que retornó el recursivo:",reco_1_fnd);

            throw BreakException_2;
          }
        });
      } catch (e) {
        if (e !== BreakException_2) throw e;
      }
    }
    console.log("retornar paso2 reco1:",reco_1_fnd);

    return reco_1_fnd;
  }
  nuevo_revisaSubcarpetaDefault_faltante_paso3(arreglo:any){
    arreglo.forEach(carpeta => {
      const coincidente = this.listaArchivosTemp.find(item => item.nombre == carpeta.carpeta);
      console.log("datos paso 3:",{
        carpeta,
        coincidente
      });

      if(coincidente == undefined){ //si la carpeta no se encontró, se crea nueva
        this.nuevo_creaSubcarpetas(this.datosCarpetaActual,carpeta);
        // console.log("creará subcarpeta");
      } else{
        console.log("se encontro coincidente, no se creará subcarpeta");

      }
    });
  }

  nuevo_revisaArchivosDefault_paso1(){
    const referencias = [
      { bandera: 'carpetaMx', arrArchivos: this.archivosInicialesMX },
      { bandera: 'carpetaCayc', arrArchivos: this.archivosInicialesCAYC },
      { bandera: 'carpetaBetter', arrArchivos: this.archivosInicialesBetter },
      // { bandera: 'carpetaPub', arrArchivos:  },
    ];
    referencias.forEach(referencia => {
      if(this.datosCarpetaActual[referencia.bandera]){
        this.nuevo_revisaArchivosDefault_paso2(this.datosCarpetaActual.nombre, referencia.arrArchivos);
      }
    });
  }
  nuevo_revisaArchivosDefault_paso2(nombreCarpeta:string, archivosDefault:any){
    let listaArchivos: any;
    var BreakException = {};
    try {
      archivosDefault.forEach(element => {
          let arrArchivos = this.archivosSubcarpetaDefault(nombreCarpeta, element, DATOS_API.urlAssets + 'cloud_mx');
          if(arrArchivos.encontrado){
            listaArchivos = arrArchivos;
            throw BreakException;
          }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
    if(listaArchivos?.archivos){
      listaArchivos.archivos.forEach((nomFile:any,i) => {
        const archivo = {
          nombre: nomFile.nombre,
          ubicacion: listaArchivos.rutaCompleta + "/",
          tamanio: nomFile.tamanio,
          archivoDef: true
        }
        this.listaArchivos.push(archivo);
      });
    }
  }
  /////SERVICIOS NUEVOS

  enviaDireccionActual(){
    this.direccionActual.emit(this.direccionRaiz);
  }
  enviaIdCarpetaActual(idCarpeta:string){
    this.enviaIdCarpeta.emit(idCarpeta);
  }

  gotoRaiz(){
    this.idCarpetaActual = null;
    this.datosCarpetaActual = null;
    // this.direccionRaiz = this.direccionRaiz + this.nombreEmpresa + "/";
    this.direccionRaiz = this.direccionRaiz + localStorage.getItem('companyID') + "/";
    this.historial = [];
    this.enviaDireccionActual();
    this.enviaIdCarpetaActual(null);
    this.getRaiz();
  }

  getRaiz(){
    let idEmpresa: string;
    if(this.datosEmpresaSS.bypass){
      idEmpresa = this.datosEmpresaSS.idEmpresa;
    }
    else{
      idEmpresa = null;
    }
    this.cloudService.getCarpetaRaiz(idEmpresa).subscribe( (data:backInter.getCarpetaRaiz) => {
      this.listaArchivos = data.carpetas;

        // this.listaArchivos.forEach(carpeta => {
        //   carpeta.tipoArchivo = 'folder';
        //   if(this.carpetasIniciales.includes(carpeta.nombre)){
        //     carpeta.carpetaDef = true;
        //   }
        // });

        if(localStorage.getItem('producto35')=="1" || localStorage.getItem('Leveuser')=="6"){
          console.log("Tipo 2 de la norma entro");
          this.listaArchivos.forEach(carpeta => {
            carpeta.tipoArchivo = 'folder';
            // if(this.carpetasInicialesBetter.includes(carpeta.nombre)){
            //   carpeta.carpetaDef = true;
            // }
            var BreakException = {};
            try {
              this.carpetasInicialesBetter.forEach((carpetaBetter, i) => {
                if(carpeta.nombre == carpetaBetter.carpeta){
                  carpeta.carpetaDef = true;
                  carpeta.carpetaBetter = true;
                  throw BreakException;
                }
              });
            } catch (e) {
                if (e !== BreakException) throw e;
            };
          });

        }

        // this.listaArchivos.forEach(carpeta => {
        //   carpeta.tipoArchivo = 'folder';
        //   var BreakException = {};
        //   try {
        //     this.carpetasInicialesAll.forEach((carpetaAll, i) => {
        //       if(carpeta.nombre == carpetaAll.carpeta){
        //         console.log("Ha entrado tió");
        //         carpeta.carpetaDef = true;
        //         carpeta.carpetaMx = true;
        //         carpeta.visible = carpetaAll.visible;
        //         throw BreakException;
        //       }
        //     });
        //   } catch (e) {
        //       if (e !== BreakException) throw e;
        //   };
        // });

        if(this.idInstituto == '1' || this.idInstituto == 'MX'){
          //carpetasDefault Mx
          this.listaArchivos.forEach(carpeta => {
            carpeta.tipoArchivo = 'folder';
            // if(this.carpetasInicialesMX.includes(carpeta.nombre)){
            //   carpeta.carpetaDef = true;
            //   carpeta.carpetaMx = true;
            // }
            var BreakException = {};
            try {
              this.carpetasInicialesMX.forEach((carpetaMx, i) => {
                if(carpeta.nombre == carpetaMx.carpeta){
                  // console.log("carpeta default mx");
                  // console.log(carpeta.nombre);
                  carpeta.carpetaDef = true;
                  carpeta.carpetaMx = true;
                  carpeta.visible = carpetaMx.visible;
                  throw BreakException;
                }
              });
            } catch (e) {
                if (e !== BreakException) throw e;
            };
            // console.log("carpRaiz: ",carpeta);
          });
        }

        if(this.idInstituto == '2' || this.idInstituto == 'CAYC'){
          this.listaArchivos.forEach(carpeta => {
            carpeta.tipoArchivo = 'folder';
            var BreakException = {};
            try {
              this.carpetasInicialesCAYC.forEach((carpetaCayc, i) => {
                if(carpeta.nombre == carpetaCayc.carpeta){
                  carpeta.carpetaDef = true;
                  carpeta.carpetaCayc = true;
                  carpeta.visible = carpetaCayc.visible;
                  throw BreakException;
                }
              });
            } catch (e) {
                if (e !== BreakException) throw e;
            };
            // console.log("carpRaiz: ",carpeta);
          });
        }

        this.listaArchivos.forEach(carpeta => {
          carpeta.tipoArchivo = 'folder';
          var BreakException = {};
          try {
            this.carpetasInicialesPublic.forEach((carpetaPub, i) => {
              if(carpeta.nombre == carpetaPub.carpeta){
                carpeta.carpetaDef = true;
                carpeta.carpetaPub = true;
                carpeta.visible = carpetaPub.visible;
                throw BreakException;
              }
            });
          } catch (e) {
              if (e !== BreakException) throw e;
          };
        });
      // }

      //quita las carpetas default que tengan "visible" como false y las carpetas ITBM
      let carpetasSinFiltro = this.listaArchivos;
      this.listaArchivos = [];
      carpetasSinFiltro.forEach(carpeta => {
        if((carpeta.carpetaDef && carpeta.carpetaMx && carpeta.carpetaCayc) || (carpeta.carpetaDef && carpeta.carpetaPub && carpeta.carpetaCayc)){
          if(carpeta.visible){
            this.listaArchivos.push(carpeta);
          }
        }
        else{
          if(!carpeta.itbm){
            this.listaArchivos.push(carpeta);
          }
        }
      });

      data.archivos.forEach(archivo => {
        archivo.nombreArchivoCode=archivo.nombre;
        this.listaArchivos.push(archivo);
      });
      this.registroVacio();
      // this.carpetasDefault();
      // this.borraCarpetasDefault();
      // this.borraCarpetasDefaultAll();
      // this.carpetasDefaultAll();
      if(localStorage.getItem('producto35')=="1" || localStorage.getItem('Leveuser')=="6"){
        this.carpetasDefault_NOM35();
      }
      if(this.idInstituto == '1' || this.idInstituto == 'MX'){
        this.carpetasDefaultMx();
      } else if(this.idInstituto == '2' || this.idInstituto == 'CAYC'){
        this.carpetasDefaultCAYC();
      }
      this.carpetasDefaultPublic();
    });
  }

  depuraHistorial(datosCarpeta:any){
    let nuevoHistorial: any[] = [];
    var BreakException = {};
    try {
      this.historial.forEach(carpeta => {
        if(carpeta._id != datosCarpeta._id){
          nuevoHistorial.push(carpeta);
        }
        else throw BreakException;
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
    this.historial = nuevoHistorial;
    this.historial.push(datosCarpeta);
    console.log("historial:",this.historial);

  }

  registroVacio(){
    if(this.listaArchivos.length == 0){
      this.listaArchivos.push({tipoArchivo: 'vacio'});
    }
  }

  archivosDefaultMx(nombreCarpeta:string){
    // let indice = this.carpetasInicialesMX.indexOf(nombreCarpeta);
    let listaArchivos: any;
    var BreakException = {};
    try {
      this.archivosInicialesMX.forEach(element => {
          let arrArchivos = this.archivosSubcarpetaDefault(nombreCarpeta, element, DATOS_API.urlAssets + 'cloud_mx');
          if(arrArchivos.encontrado){
            listaArchivos = arrArchivos;
            // console.log("Lista archivos:",listaArchivos);
            throw BreakException;
          }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };

    if(listaArchivos.archivos){
      listaArchivos.archivos.forEach((nomFile:any,i) => {
        let archivo = {
          nombre: nomFile.nombre,
          ubicacion: listaArchivos.rutaCompleta + "/",
          tamanio: nomFile.tamanio,
          archivoDef: true
        }
        this.listaArchivos.push(archivo);
      });
    }

    // let indice = -1;
    // this.carpetasInicialesMX.forEach((carpetaMx, i) => {
    //   console.log("nomCarpeta: ",nombreCarpeta, " | carpMx: ",carpetaMx.carpeta);
    //   if(nombreCarpeta == carpetaMx.carpeta){
    //     indice = i;
    //
    //   }
    // });
    // console.log("indice: ",indice);
    // if(indice >= 0){
    //   const archivos = this.archivosInicialesMX[indice].archivos;
    //
    //   console.log("indice = ",indice);
    //   console.log("archivos: ",archivos);
    //
    //   if(archivos){
    //     archivos.forEach((nomFile:any,i) => {
    //       let archivo = {
    //         nombre: nomFile.nombre,
    //         ubicacion: DATOS_API.urlAssets + 'cloud_mx/'+indice+'/',
    //         tamanio: nomFile.tamanio,
    //         archivoDef: true
    //       }
    //       this.listaArchivos.push(archivo);
    //     });
    //   }
    // }
  }

  archivosDefaultCAYC(nombreCarpeta:string){
    // let indice = this.carpetasInicialesMX.indexOf(nombreCarpeta);
    let listaArchivos: any;
    var BreakException = {};
    try {
      this.archivosInicialesCAYC.forEach(element => {
          let arrArchivos = this.archivosSubcarpetaDefault(nombreCarpeta, element, DATOS_API.urlAssets + 'cloud_mx');
          if(arrArchivos.encontrado){
            listaArchivos = arrArchivos;
            // console.log("Lista archivos:",listaArchivos);
            throw BreakException;
          }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };

    if(listaArchivos.archivos){
      listaArchivos.archivos.forEach((nomFile:any,i) => {
        let archivo = {
          nombre: nomFile.nombre,
          ubicacion: listaArchivos.rutaCompleta + "/",
          tamanio: nomFile.tamanio,
          archivoDef: true
        }
        this.listaArchivos.push(archivo);
      });
    }
  }

  archivosSubcarpetaDefault(nombreCarp: string, carpetaActual: any, ruta: string){

    let archivos: any;
    let encontrado: boolean;
    let rutaCompleta = ruta;
    if(carpetaActual.carpeta == nombreCarp){
      archivos = carpetaActual.archivos;
      encontrado = true;
      rutaCompleta = rutaCompleta + "/" + carpetaActual.carpeta;
      // console.log("ruta final via 1: ",rutaCompleta);
    }
    else{
      if(carpetaActual.subcarpeta){
        if(carpetaActual.subcarpeta.length > 0){
          var BreakException = {};
          try {
            rutaCompleta = rutaCompleta + "/" + carpetaActual.carpeta;
            carpetaActual.subcarpeta.forEach((carpetaMx, i) => {
              let datosSub = this.archivosSubcarpetaDefault(nombreCarp,carpetaMx,rutaCompleta);
              if(datosSub.encontrado){
                archivos = datosSub.archivos;
                encontrado = datosSub.encontrado;
                rutaCompleta = datosSub.rutaCompleta;
                // console.log("ruta final via2: ",rutaCompleta);
                throw BreakException;
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          };
        }
      }
    }
    // console.log("resutlados archivosSubcarpetaDefault: ",archivos,encontrado,rutaCompleta);
    return {encontrado,archivos,rutaCompleta};
  }

  // archivosDefaulBetter(nombreCarpeta:string){
  //   let indice = this.carpetasInicialesBetter.indexOf(nombreCarpeta);
  //   console.log("Indice");
  //   console.log(indice);
  //   this.archivosInicialesBetter[indice].archivos.forEach((nomFile:any,i) => {
  //     let archivo = {
  //       nombre: nomFile.nombre,
  //       ubicacion: DATOS_API.urlAssets + 'cloud_mx/'+indice+'/',
  //       tamanio: nomFile.tamanio,
  //       archivoDef: true
  //     }
  //     this.listaArchivos.push(archivo);
  //   });
  // }
  archivosDefaulBetter(nombreCarpeta:string){
    // let indice = this.carpetasInicialesMX.indexOf(nombreCarpeta);
    let listaArchivos: any;
    var BreakException = {};
    try {
      this.archivosInicialesBetter.forEach(element => {
          let arrArchivos = this.archivosSubcarpetaDefault(nombreCarpeta, element, DATOS_API.urlAssets + 'cloud_mx');
          if(arrArchivos.encontrado){
            listaArchivos = arrArchivos;
            // console.log("Lista archivos:",listaArchivos);
            throw BreakException;
          }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };

    if(listaArchivos.archivos){
      listaArchivos.archivos.forEach((nomFile:any,i) => {
        let archivo = {
          nombre: nomFile.nombre,
          ubicacion: listaArchivos.rutaCompleta + "/",
          tamanio: nomFile.tamanio,
          archivoDef: true
        }
        this.listaArchivos.push(archivo);
      });
    }
  }

  archivosDefaultNewCO(nombreCarpeta:string){
    // let indice = this.carpetasInicialesMX.indexOf(nombreCarpeta);
    let listaArchivos: any;
    var BreakException = {};
    try {
      this.archivosInicialesNewCO.forEach(element => {
          let arrArchivos = this.archivosSubcarpetaDefault(nombreCarpeta, element, DATOS_API.urlAssets + 'cloud_mx');
          if(arrArchivos.encontrado){
            listaArchivos = arrArchivos;
            // console.log("Lista archivos:",listaArchivos);
            throw BreakException;
          }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };

    if(listaArchivos.archivos){
      listaArchivos.archivos.forEach((nomFile:any,i) => {
        let archivo = {
          nombre: nomFile.nombre,
          ubicacion: listaArchivos.rutaCompleta + "/",
          tamanio: nomFile.tamanio,
          archivoDef: true
        }
        this.listaArchivos.push(archivo);
      });
    }
  }

  carpetasDefault(){
    console.log("Carpetas Default");
    console.log(this.listaArchivos);

    this.listaArchivos.forEach(carpeta => {
      if(carpeta.tipoArchivo == 'folder'){
        if(carpeta.nombre == 'Información TI') this.boolsCarpInic[0] = true;
        if(carpeta.nombre == 'Información CA') this.boolsCarpInic[1] = true;
        if(carpeta.nombre == 'Información General') this.boolsCarpInic[2] = true;
      }
    });
    // //si alguna de las carpetas default falta
    // if(!this.boolsCarpInic[0]){
    //   //crea primera carpeta y subcarpeta
    //   this.creaCarpetaDef('Información TI', 'Intercambio de BD', 0,1);
    // }
    // if(!this.boolsCarpInic[1]){
    //   //crea segunda carpeta y subcarpeta
    //   this.creaCarpetaDef('Información CA', 'Intercambio de Archivos CA', 1,1);
    // }
    // if(!this.boolsCarpInic[2]){
    //   //crea tercera carpeta y subcarpeta
    //   this.creaCarpetaDef('Información General', 'Selector de templates', 2,1);
    // }
  }

  // carpetasDefault_NOM35(){
  //   this.listaArchivos.forEach(carpeta => {
  //     if(carpeta.tipoArchivo == 'folder'){
  //       let indice = this.carpetasInicialesBetter.indexOf(carpeta.nombre);
  //       if(indice != -1){
  //         this.boolsCarpInicBetter[indice] = true;
  //       }
  //     }
  //   });
  //   this.carpetasInicialesBetter.forEach((nombre,i) => {
  //     if(!this.boolsCarpInicBetter[i])
  //       this.creaCarpetaDef(nombre,i,3);
  //   });
  // }

  carpetasDefault_NOM35(){
    console.log("Carpetas Default Nom35");
    console.log(this.listaArchivos);
    this.listaArchivos.forEach(carpetaActual => {
      if(carpetaActual.tipoArchivo == 'folder'){
        this.carpetasInicialesBetter.forEach((carpetaBetter, i) => {
          if(carpetaActual.nombre == carpetaBetter.carpeta){
            this.boolsCarpInicBetter[i] = true;
          }
        });
      }
    });
    console.log("boolsBetter: ",this.boolsCarpInicBetter);
    this.carpetasInicialesBetter.forEach((carpetaBetter,i) => {
      if(!this.boolsCarpInicBetter[i])
        this.creaCarpetaDef(carpetaBetter,i,3);
    });
  }

  carpetasDefaultMx(){
    console.log("Carpetas DefaultMx");
    console.log(this.listaArchivos);
    this.listaArchivos.forEach(carpetaActual => {
      if(carpetaActual.tipoArchivo == 'folder'){
        // let indice = this.carpetasInicialesMX.indexOf(carpeta.nombre);
        // if(indice != -1){
        //   this.boolsCarpInicMX[indice] = true;
        // }
        this.carpetasInicialesMX.forEach((carpetaMx, i) => {
          if(carpetaActual.nombre == carpetaMx.carpeta){
            this.boolsCarpInicMX[i] = true;
          }
        });
      }
    });
    console.log("boolsMx: ",this.boolsCarpInicMX);

    this.carpetasInicialesMX.forEach((carpetaMx,i) => {
      if(!this.boolsCarpInicMX[i])
        this.creaCarpetaDef(carpetaMx,i,2);
    });
  }

  carpetasDefaultCAYC(){
    console.log("Carpetas DefaultMx");
    console.log(this.listaArchivos);
    this.listaArchivos.forEach(carpetaActual => {
      if(carpetaActual.tipoArchivo == 'folder'){
        this.carpetasInicialesCAYC.forEach((carpetaCAYC, i) => {
          if(carpetaActual.nombre == carpetaCAYC.carpeta){
            this.boolsCarpInicCAYC[i] = true;
          }
        });
      }
    });
    console.log("boolsCAYC: ",this.boolsCarpInicCAYC);

    this.carpetasInicialesCAYC.forEach((carpetaCAYC,i) => {
      if(!this.boolsCarpInicCAYC[i])
        this.creaCarpetaDef(carpetaCAYC,i,6);
    });
  }

  carpetasDefaultAll(){
    console.log("Carpetas todos");
    console.log(this.listaArchivos);
    this.listaArchivos.forEach(carpetaActual => {
      if(carpetaActual.tipoArchivo == 'folder'){

        this.carpetasInicialesAll.forEach((carpetaAll, i) => {
          if(carpetaActual.nombre == carpetaAll.carpeta){
            this.boolsCarpInicAll[i] = true;
          }
        });
      }
    });
    //console.log("boolsMx: ",this.boolsCarpInicMX);

    this.carpetasInicialesAll.forEach((carpetaAll,i) => {
      if(!this.boolsCarpInicAll[i])
        this.creaCarpetaDef(carpetaAll,i,4);
    });
  }

  carpetasDefaultPublic(){
    this.listaArchivos.forEach(carpetaActual => {
      if(carpetaActual.tipoArchivo == 'folder'){

        this.carpetasInicialesPublic.forEach((carpetaPublic, i) => {
          if(carpetaActual.nombre == carpetaPublic.carpeta){
            this.boolsCarpInicPublic[i] = true;
          }
        });
      }
    });
    //console.log("boolsMx: ",this.boolsCarpInicMX);

    this.carpetasInicialesPublic.forEach((carpetaPublic,i) => {
      if(!this.boolsCarpInicPublic[i])
        this.creaCarpetaDef(carpetaPublic,i,4);
    });
  }


  creaCarpetaDef(nomCarpeta: any, numCarpeta: number, origen: number){
    let idEmpresa: string;
    if(this.datosEmpresaSS.bypass){
      idEmpresa = this.datosEmpresaSS.idEmpresa;
    }
    else{
      idEmpresa = null;
    }
    let datos:any = {
      nombre: nomCarpeta.carpeta,
      ubicacion: this.direccionRaiz
    };
    this.cloudService.guardaCarpeta(datos,idEmpresa).subscribe((respuesta:backInter.guardaCarpeta) => {
      if(respuesta.success){
        let completo = true;
        switch (origen) {
          case 1:
            this.boolsCarpInic[numCarpeta] = true;
            if(this.boolsCarpInic[0] && this.boolsCarpInic[1] && this.boolsCarpInic[2]){
              this.actualizarLista();
            }
          break;
          case 2: //carpetas iniciales mx
            this.boolsCarpInicMX[numCarpeta] = true;
            this.boolsCarpInicMX.forEach(listo => {
              if(!listo)
                completo = false;
            });
            if(completo)
              this.actualizarLista();
          break;
          case 3: //carpetas nom35
            this.boolsCarpInicBetter[numCarpeta] = true;
            this.boolsCarpInicBetter.forEach(listo => {
              if(!listo)
                completo = false;
            });
            if(completo)
              this.actualizarLista();
          break;
          case 4:
            this.boolsCarpInicAll[numCarpeta] = true;
            this.boolsCarpInicAll.forEach(listo => {
              if(!listo)
                completo = false;
            });
            if(completo)
              this.actualizarLista();
          break;
          case 5:
            this.boolsCarpInicPublic[numCarpeta] = true;
            this.boolsCarpInicPublic.forEach(listo => {
              if(!listo)
                completo = false;
            });
            if(completo)
              this.actualizarLista();
          break;
          case 6:
            this.boolsCarpInicCAYC[numCarpeta] = true;
            this.boolsCarpInicCAYC.forEach(listo => {
              if(!listo)
                completo = false;
            });
            if(completo)
              this.actualizarLista();
          break;
        }

        //subcarpetas de subcarpetas a ver si jala alv
        if(nomCarpeta.subcarpeta.length > 0){
          nomCarpeta.subcarpeta.forEach((subcarpeta) => {
            this.creaSubcarpetas(respuesta,subcarpeta);
          });
        }
      }
    }, error => {
      console.log(error);
    });
  }
  creaSubcarpetas(padre:any, actual:any){
    console.log("entro a crear subcarpeta");
    console.log(padre);
    let datos:any = {
      nombre: actual.carpeta,
      ubicacion: padre.carpeta.ubicacion + padre.carpeta.nombre + "/" + actual.carpeta,
      carpetaId: padre.carpeta._id
    };
    console.log(datos);
    let idEmpresa: string;
    if(this.datosEmpresaSS.bypass){
      idEmpresa = this.datosEmpresaSS.idEmpresa;
    }
    else{
      idEmpresa = null;
    }
    this.cloudService.guardaCarpeta(datos,idEmpresa).subscribe((respuesta:backInter.guardaCarpeta) => {
      if(respuesta.success){
        console.log("datos subcarpeta: ",actual);

        if(actual.subcarpeta.length > 0){
          actual.subcarpeta.forEach((subcarpeta) => {
            this.creaSubcarpetas(respuesta,subcarpeta);
          });
        }
      }
    });
  }

  borraCarpetasDefault(){
    let carpetasExistentes:any[] = [];
    this.listaArchivos.forEach(carpeta => {
      if(carpeta.tipoArchivo == 'folder'){
        let indice = this.carpetasIniciales.indexOf(carpeta.nombre);
        if(indice != -1 && carpeta.carpetaDef){
          carpetasExistentes.push({indice,carpeta});
        }
      }
    });
    carpetasExistentes.forEach(nombre => {
      // console.log(nombre.carpeta, nombre.indice);
      this.borraCarpetaDef(nombre.carpeta._id,nombre.indice);
    });
  }
  borraCarpetasDefaultAll(){
    let carpetasExistentes:any[] = [];
    this.listaArchivos.forEach(carpeta => {
      if(carpeta.tipoArchivo == 'folder'){
        // let indice = this.carpetasInicialesAll.indexOf(carpeta.nombre);
        let indice = this.carpetasInicialesAll.findIndex(item => item.carpeta == carpeta.nombre);
        if(indice != -1 && carpeta.carpetaDef){
          carpetasExistentes.push({indice,carpeta});
        }
      }
    });
    carpetasExistentes.forEach(nombre => {
      // console.log(nombre.carpeta, nombre.indice);
      this.borraCarpetaDef(nombre.carpeta._id,nombre.indice);
    });
  }
  borraCarpetaDef(idArchivo:string, numCarpeta:number){
    console.log("borra carpeta default");
    console.log(idArchivo + " - " + numCarpeta);
    this.cloudService.borraCarpeta(idArchivo).subscribe( (data:backInter.RespuestaGen) => {
    if(data.success){
      this.boolsCarpInic[numCarpeta] = false;
      let completo = true;
      this.boolsCarpInic.forEach(listo => {
        if(listo)
          completo = false;
      });
      if(completo)
        this.actualizarLista();
      }
      console.log(data);
    });
  }

  getCarpeta(datosCarpeta:any, actualiza?:boolean){
    // console.log(datosCarpeta);

    if(this.idCarpetaActual != datosCarpeta._id || actualiza){
      this.depuraHistorial(datosCarpeta);
      this.datosCarpetaActual = datosCarpeta;
      this.idCarpetaActual = datosCarpeta._id;
      this.direccionRaiz = this.direccionRaiz + datosCarpeta.nombre + "/";
      this.enviaDireccionActual();
      this.enviaIdCarpetaActual(datosCarpeta._id);
      this.cloudService.getCarpeta(datosCarpeta._id).subscribe( (data:any) => {
        console.log(data);
        this.listaArchivos = data.subcarpetas;
        this.listaArchivos.forEach(carpeta => {
          console.log('entro el foreach =>');

          carpeta.tipoArchivo = 'folder';

          if(datosCarpeta.carpetaMx){
            //buscar archvos subcarpeta
            if(this.buscaSubcarpetaDefault(carpeta.nombre, this.carpetasInicialesMX)){
              carpeta.carpetaDef = true;
              carpeta.carpetaMx = true;
            }
          }

          if(datosCarpeta.carpetaBetter){
            //buscar archvos subcarpeta
            if(this.buscaSubcarpetaDefault(carpeta.nombre, this.carpetasInicialesBetter)){
              carpeta.carpetaDef = true;
              carpeta.carpetaBetter = true;
            }
          }

          if(datosCarpeta.carpetaCayc){
            //buscar archvos subcarpeta
            if(this.buscaSubcarpetaDefault(carpeta.nombre, this.carpetasInicialesCAYC)){
              carpeta.carpetaDef = true;
              carpeta.carpetaCayc = true;
            }
          }

        });

        data.archivos.forEach(archivo => {
          archivo.nombreArchivoCode=archivo.nombre
          this.listaArchivos.push(archivo);
        });
        console.log(datosCarpeta);
        console.log(this.listaArchivos);

        if(datosCarpeta.carpetaMx){
          this.archivosDefaultMx(datosCarpeta.nombre);
        }
        if(datosCarpeta.carpetaCayc){
          this.archivosDefaultCAYC(datosCarpeta.nombre);
        }

        if(datosCarpeta.carpetaBetter){
          console.log("Dude");
          console.log(localStorage.getItem('tipoNorma35'));
          this.archivosDefaulBetter(datosCarpeta.nombre);
        }

        this.registroVacio();

      });
    }
  }


  buscaSubcarpetaDefault(nombreCarp: string, carpetaActual: any, fase?: number){
    let encontrado: boolean;
    // this.carpetasInicialesMX.forEach((carpetaMx, i) => {

    let arreglo: any = fase != undefined ? carpetaActual.subcarpeta : carpetaActual;
    // if(fase){ arreglo = carpetaActual.subcarpeta; }
    // else{ arreglo = carpetaActual; }
    console.log(nombreCarp,carpetaActual,fase,"arreglo a recorrer:", arreglo);

    var BreakException = {};
    try {
      arreglo.forEach((carpetaDefault, i) => {
        console.log("nombre: ", nombreCarp, " | carpetaArreglo: ", carpetaDefault.carpeta);
        if(nombreCarp == carpetaDefault.carpeta){
          console.log("coincidio:",nombreCarp," == ",carpetaDefault.carpeta);

          encontrado = true;
          throw BreakException;
        }
        else{
          if(carpetaDefault.subcarpeta.length > 0){
            encontrado = this.buscaSubcarpetaDefault(nombreCarp,carpetaDefault,2);
            if(encontrado == true){
              throw BreakException;
            }
          }
          else{
            if(nombreCarp == carpetaDefault.carpeta){
              encontrado = true;
              throw BreakException;
            }
          }
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
    console.log("hará return :",encontrado);

    return encontrado;
  }

  guardaArchivoNuevo(evt: any){
    this.archivoNuevo.emit(evt);
  }

  guardaCarpeta(){
    let regexNombre = new RegExp("^[a-zA-Z0-9 _]*$");
    let texto = 'FILEMANAGER.MENSAJES.CREATEFOLDER';
    let rspSi = 'FILEMANAGER.MENSAJES.BOTONES.CREAR';
    let rspNo = 'FILEMANAGER.MENSAJES.BOTONES.CANCELAR';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    Swal.fire({
      title: texto,
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: rspSi,
      cancelButtonText: rspNo,
      showLoaderOnConfirm: true,

      allowOutsideClick: () => !Swal.isLoading(),
      inputValidator: (value) => {
        if (!regexNombre.test(value)) {
          return this.translateSrv.instant('FILEMANAGER.MENSAJES.INVALID_CHARS')
        }
      }
    }).then((result) => {
      if (result.value) {
        // console.log(result.value);

        let datos:any = {
          nombre: result.value,
          ubicacion: this.direccionRaiz
        };
        if(this.idCarpetaActual){
          datos.carpetaId = this.idCarpetaActual;  //solo cuando no es la raiz
        }
        console.log(datos);

        let idEmpresa: string;
        if(this.datosEmpresaSS.bypass){
          idEmpresa = this.datosEmpresaSS.idEmpresa;
        }
        else{
          idEmpresa = null;
        }


        this.cloudService.guardaCarpeta(datos,idEmpresa).subscribe((respuesta:backInter.guardaCarpeta) => {
          console.log(respuesta);
          if(respuesta.success){
            this.mensajeSwal('FILEMANAGER.MENSAJES.FOLDEROK',1);
            this.actualizarLista();
          }
          else{
            this.mensajeSwal('FILEMANAGER.MENSAJES.'+respuesta.message,3);
          }
        }, error => {
          console.log(error);
        });

      }
    });
  }

  actualizarLista_back(){
    if(!this.idCarpetaActual){
      this.getRaiz();
      // this.nuevo_gotoRaiz();
    }
    else{
      this.getCarpeta(this.datosCarpetaActual, true);
      // this.nuevo_getCarpeta(this.datosCarpetaActual);
    }
  }

  actualizarLista(){
    if(!this.idCarpetaActual){
      this.versionCloudNueva == true ? this.nuevo_gotoRaiz() : this.getRaiz();
    }
    else{
      this.versionCloudNueva == true ? this.nuevo_getCarpeta(this.datosCarpetaActual) : this.getCarpeta(this.datosCarpetaActual, true);
    }
  }

  borraArchivo(idArchivo:string, opcion:number){
    let texto:string;
    switch (opcion) {
      case 1: texto = 'FILEMANAGER.MENSAJES.DELETERLY'; break;
      case 2: texto = 'FILEMANAGER.MENSAJES.DELETEFOLDERRLY'; break;
    }
    let rspSi = 'FILEMANAGER.MENSAJES.BOTONES.SI';
    let rspNo = 'FILEMANAGER.MENSAJES.BOTONES.NO';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        switch (opcion) {
          case 1: //archivo
            this.cloudService.borraArchivo(idArchivo).subscribe( (data:backInter.RespuestaGen) => {
              if(data.success){
                this.mensajeSwal('FILEMANAGER.MENSAJES.DELETEOK',1);
                this.actualizarLista();
              }
              console.log(data);
            });
          break;
          case 2: //carpeta
            this.cloudService.borraCarpeta(idArchivo).subscribe( (data:backInter.RespuestaGen) => {
            if(data.success){
                this.mensajeSwal('FILEMANAGER.MENSAJES.DELETEFOLDEROK',1);
                this.actualizarLista();
              }
              console.log(data);
            });
          break;
        }
      }
    });


  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let texto = '';
    this.translateSrv.get(mensaje).subscribe((res: string) => { texto = res; });
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: texto,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  encode(content: string){
    console.log('content',content);
    return encodeURIComponent(content);
  }
}
